import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { FeedbackApi } from 'api';
import { SearchFeedbackQueryType } from 'types';

function useGetAll(query: SearchFeedbackQueryType, enabled = true) {
  return useAuthQuery(
    getQueryKeys([KEY]).list({ ...query }),
    () => FeedbackApi.getAll(query),
    {
      select: (data) => data.data,
      enabled,
    },
  );
}

export default useGetAll;
